import Vue from 'vue'
import Router from 'vue-router'
import routes from './path'
import store from '../store'
import { hasPermission, isTokenExpired } from '../utils'
import axios from '@/plugins/axios'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

async function getSettings() {
  try {
    const { data } = await axios.get(`api/v1/publicSettings`)
    return data.data
  } catch (e) {
    console.log(e)
  }
}

function getMaintenance(settings) {
  const item = settings.find(item => item.key === 'maintenance')
  return item?.value
}

function getLoginTokenRedirect(settings) {
  const item = settings.find(item => item.key === 'login_token_redirect')
  return item?.value
}

function tokenExpired(token) {
  return isTokenExpired(token)
}

function isExecutive(user) {
  return (
    user?.authorityLevelsCode === 1 ||
    user?.authorityLevelsCode === 2 ||
    user?.authorityLevelsCode === 4
  )
}

function isAccountCode(user, account) {
  return (
    user?.avobjects?.findIndex(
      item =>
        item.code === account.code && item.typeCode === 'accountCode'
    ) > -1
  )
}

/**
 * Protegemos las rutas para que solo puedan acceder
 * si el usuario esta autentificado, de lo contrario
 * lo redirigimos a la ventana de Login
 */
router.beforeEach(async (to, from, next) => {
  const user = store.state.auth.user
  const auth = to.matched.some(m => m.meta.auth)
  const authFrom = from.matched.some(m => m.meta.auth)
  const permission = to.meta?.permission
  const guest = to.meta?.guest
  const account = store.state.account.account

  const settings = await getSettings()
  const maintenance = getMaintenance(settings)
  const loginTokenRedirect = getLoginTokenRedirect(settings)

  const validRoutesToToken = [
    'ResetPassword',
    'ConfigPassword',
    'ForgotPassword'
  ]

  const isValidRouteToToken = validRoutesToToken.includes(to.name)

  // Redirect on token expired
  if (
    loginTokenRedirect &&
    !from.name &&
    !auth &&
    !user &&
    !isValidRouteToToken
  ) {
    const { token } = to.query
    const isTokenExpired = tokenExpired(token)

    if (isTokenExpired) {
      const url = process.env.VUE_APP_REDIRECT_URL || 'https://www.avsecurities.com'
      window.location.replace(url)
    }
  }

  // Maintenance mode
  if (to.name !== 'Maintenance' && maintenance) {
    next({ name: 'Maintenance' })
  } // Authentication
  else if (auth && !user) {
    const { token } = to?.query
    next({ name: 'Login', query: { token } })
  } // Not account selected
  else if (auth && !account && to.name === 'Delete') {
    next()
  } // PermanentInstruction auth
  else if (to.name === 'PermanentInstructionsCreate' && !to.query?.redirect) {
    if (isExecutive(user) && !isAccountCode(user, account)) {
      next({ name: 'PermanentInstructions' })
    }
    next()
  } else if (auth && !account && to.name !== 'AccountSelect') {
    next({ name: 'AccountSelect' })
  } // Guest redirect
  else if (authFrom && guest) {
    if (!account) next({ name: 'AccountSelect' })
    else next({ name: 'Home' })
  } // Route permission
  else if (auth && permission && !hasPermission(user, permission)) {
    next({ name: 'Home' })
  } else next()
})

export default router
